import { ReactNode } from 'react';
import { ArrowLeftIcon, Grid } from '@forgeglobal/design-framework';
import BaseLayout from './BaseLayout';
import useStyles from './style';

interface DialogPageLayoutProps {
  backgroundColor?: string;
  children: ReactNode;
  header?: ReactNode;
  footer?: ReactNode;
  footerHeight?: number;
  showCloseArrow?: boolean;
  shouldShowUser?: boolean;
  handleExit?: () => void;
}

// Should be used for dedicated page with "Dialog looks-like" appearance, with no overlaying. In other case use DialogLayout.
const DialogPageLayout = ({
  showCloseArrow = true,
  shouldShowUser,
  backgroundColor,
  children,
  header,
  footer,
  footerHeight,
  handleExit,
  ...rest
}: DialogPageLayoutProps) => {
  const classes = useStyles({
    footerHeight: footerHeight,
  });

  return (
    <BaseLayout shouldShowUser={shouldShowUser} className={classes.mainWrapper}>
      {header}
      {showCloseArrow && (
        <div className={classes.arrowContainer}>
          <ArrowLeftIcon
            data-test-id="arrow-button"
            onClick={handleExit}
            className={classes.arrow}
          />
        </div>
      )}
      <Grid container justifyContent="center">
        {children}
      </Grid>
      {footer && (
        <Grid
          container
          alignContent="center"
          justifyContent="center"
          className={classes.footer}>
          {footer}
        </Grid>
      )}
    </BaseLayout>
  );
};

export default DialogPageLayout;
